// extracted by mini-css-extract-plugin
export default {"page":"FormContent_page__6SbZk","content":"FormContent_content__FEgR6","cards":"FormContent_cards__EltL3"};